import Vue from 'vue'
import Router from 'vue-router'
import CallWorkspace from './views/CallWorkspace.vue'
import CallWorkList from './views/CallWorkList.vue'
import VueCookies from 'vue-cookies'
import Login from '@/views/Login.vue'
// const Login = () => import('./views/Login.vue')
import Call from '@/views/Call.vue'
// import DingLogin from '@/views/DingLogin.vue'
import { RefreshToken } from '@/api/QkidsApi.js'
Vue.use(VueCookies)
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      name: 'LoginDing',
      component: Login
    },
    {
      path: '/call',
      name: 'Call',
      component: Call,
      children: [
        { path: '/', name: 'Home', redirect: '/call/work' },
        { path: 'work', name: 'Work', component: CallWorkspace },
        { path: 'list', name: 'List', component: CallWorkList },
        {
          path: 'report',
          name: 'Report',
          component: () => import('@/views/Report.vue')
        },
        { path: 'dashboard', name: 'dashboard', component: () => import('@/views/ReportDashboard.vue') }
      ]
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.fullPath === '/' || to.name === 'Login') {
    next()
  } else {
    var nowdate = getdate()
    console.log('router befor:', nowdate, to, from)
    if (localStorage.refreshDate !== nowdate) {
      RefreshToken()
        .then(req => {
          if (req.status === 200) {
            localStorage.refreshDate = nowdate
            localStorage.token = req.data.access_token
            localStorage.refreshToken = req.data.refresh_token
          }
          console.log('create req:' + req)
          next()
        })
        .catch(err => {
          next()
          console.log(err)
        })
      next()
      console.log('App is create')
    } else {
      next()
    }
  }
})
router.afterEach((to, from) => {
  console.log('router after', to, from)
})

function getdate () {
  var date = new Date()
  var nowMonth = date.getMonth() + 1
  var strDate = date.getDate()
  var seperator = '-'
  if (nowMonth >= 1 && nowMonth <= 9) {
    nowMonth = '0' + nowMonth
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var nowDate = date.getFullYear() + seperator + nowMonth + seperator + strDate
  return nowDate
}
export default router
